module.exports = __webpack_public_path__ + "img/surveyvisitplanning.8ee0c5ee.png";